import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { WebUrl } from "shared-web/lib/webUrl"

import { customer } from "./customers"

export function job(id?: PBUUID): WebUrl {
  return customer(id)
}
